// fieldtypes

import registry from "../../registry"

export default {
    ...registry.fieldtypes,
};
